// FILE: src/Comman Components/CountryDropdown.js (FULLY UPDATED)

import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { fetchCountries } from '../services/common';

const { Option } = Select;

export default function CountryDropdown({ value, onChange }) {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchCountries()
            .then(data => {
                setCountries(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    return (
        <Select
            showSearch
            value={value}
            onChange={onChange}
            loading={loading}
            placeholder="Select country"
            style={{ width: '100%' }}
            className="brand-kit-select"
            popupClassName="brand-kit-select-popup"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {countries.map(country => (
                <Option key={country} value={country}>
                    {country}
                </Option>
            ))}
        </Select>
    );
}